<template>
  <v-container grid-list-lg class="pa-0 ma-" fluid>
    <div class="special-container" style="padding: 0 50px">
      <v-flex md12 xs12>
        <v-layout class="flex-custom-classificacao">
          <v-btn color="primary" flat outline round>
            Status
          </v-btn>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="buscarVeiculoQuery()"
                  label="Busca"
                  hint="Busca por nome"
                  autofocus
                  clearable
                  v-on:change="buscarVeiculoQuery()"
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-layout row class="bloco-btn-segundo" md12 xs12>
        <v-btn
          color="secondary"
          @click="dialogClassificacaoCotacao = true"
          round
        >
          Adicionar
        </v-btn>
      </v-layout>
      <template style="margin: 0 20px;">
        <div>
          <v-data-table
            :headers="headerGridClassificacao"
            :items="listaClassificacao"
            hide-actions
            :rows-per-page-items="[10]"
            item-key="item"
            class="elevation-1 table-grid"
          >
            <template v-slot:no-data>
              <p class="no-data-apolice">Nenhum resultado encontrado.</p>
            </template>
            <template v-slot:items="props">
              <td class="themeGrey--text">
                <v-tooltip v-if="props.item.nome.length > 18" bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{
                        props.item.nome.substring(0, 19).concat("...")
                      }}
                    </span>
                  </template>
                  <span  style="margin-top: 50px">{{ props.item.nome }}</span>
                </v-tooltip>
                <span v-else>{{ props.item.nome }}</span>
              </td>
              <td class="themeGrey--text">
                <star-rating
                  v-model="props.item.classificacao"
                  :star-size="18"
                  v-bind:increment="0.5"
                  read-only
                />
              </td>
              <td class="themeGrey--text">
                <v-tooltip v-if="props.item.listaCategoriaTarifaria.length > 1" bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <span
                        v-for="(item, index) in props.item
                          .listaCategoriaTarifaria"
                      >
                      <span v-if="index == 0">
                          {{
                            buscarTitulo(item.idTipoTarifaria, listaCategorias) +
                              ","
                          }}
                        </span>
                        
                      <span
                        v-if="
                          props.item.listaCategoriaTarifaria.length > 1 &&
                            index == 1
                        "
                      >
                        {{
                          buscarTitulo(item.idTipoTarifaria, listaCategorias) + ", ..."
                        }}
                      </span>
                    </span>
                  </span>
                  </template>
                  <span >
                    <span class="ma-0" v-for="item in props.item.listaCategoriaTarifaria">
                      {{
                        buscarTitulo(item.idTipoTarifaria, listaCategorias) +", "
                      }}
                    </span>
                  </span>
                </v-tooltip>
                <span v-else> 
                  <p class="ma-0" v-for="item in props.item.listaCategoriaTarifaria">
                    {{
                      buscarTitulo(item.idTipoTarifaria, listaCategorias) 
                    }}
                  </p>
                </span>
              </td>
              <td class="themeGrey--text">
                <v-tooltip v-if="props.item.listaCobertura.length > 1" bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <span
                        v-for="(item, index) in props.item
                          .listaCobertura"
                      >
                      <span v-if="index == 0">
                          {{
                            buscarTitulo(item.idTipoCobertura, listaCoberturas) +
                              ","
                          }}
                        </span>
                        
                      <span
                        v-if="
                          props.item.listaCobertura.length > 1 &&
                            index == 1
                        "
                      >
                        {{
                          buscarTitulo(item.idTipoCobertura, listaCoberturas) + ", ..."
                        }}
                      </span>
                    </span>
                  </span>
                  </template>
                  <span >
                    <span class="ma-0" v-for="item in props.item.listaCobertura">
                      {{
                        buscarTitulo(item.idTipoCobertura, listaCoberturas) +", "
                      }}
                    </span>
                  </span>
                </v-tooltip>
                <span v-else>
                  <p class="ma-0" v-for="item in props.item.listaCobertura">
                    {{
                      buscarTitulo(item.idTipoCobertura, listaCoberturas) 
                    }}
                  </p>
                </span>
              </td>
              <td class="themeGrey--text">
                <v-tooltip v-if="props.item.listaCargaTrasnportada.length > 1"  bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <span
                        v-for="(item, index) in props.item
                          .listaCargaTrasnportada"
                      >
                      <span v-if="index == 0">
                          {{
                            buscarTitulo(item.idTipoCarga, listaCargas) +
                              ","
                          }}
                        </span>
                        
                      <span
                        v-if="
                          props.item.listaCargaTrasnportada.length > 1 &&
                            index == 1
                        "
                      >
                        {{
                          buscarTitulo(item.idTipoCarga, listaCargas) + ", ..."
                        }}
                      </span>
                    </span>
                  </span>
                  </template>
                  <span >
                    <span class="ma-0" v-for="item in props.item.listaCargaTrasnportada">
                      {{
                        buscarTitulo(item.idTipoCarga, listaCargas) +", "
                      }}
                    </span>
                  </span>
                </v-tooltip>
                <span v-else>
                  <p class="ma-0" v-for="item in props.item.listaCargaTrasnportada">
                    {{
                      buscarTitulo(item.idTipoCarga, listaCargas)
                    }}
                  </p>
                </span>
              </td>
              <td class="themeGrey--text">
                <v-tooltip v-if=" props.item.listaCorretor != null && props.item.listaCorretor.length > 1" bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <span
                        v-for="(item, index) in props.item
                          .listaCorretor"
                      >
                      <span v-if="index == 0">
                          {{
                            buscarEmail(item.idCorretor, listaCorretorResponsavel) +
                              ", "
                          }}
                        </span>
                        
                      <span
                        v-if="
                          props.item.listaCorretor.length > 1 &&
                            index == 1
                        "
                      >
                        {{
                          buscarEmail(item.idCorretor, listaCorretorResponsavel) + ", ..."
                        }}
                      </span>
                    </span>
                  </span>
                  </template>
                  <span class="regiao-tooltip" >
                    <span class="ma-0" v-for="item in props.item.listaCorretor">
                      {{
                        buscarEmail(item.idCorretor, listaCorretorResponsavel) +", "
                      }}
                    </span>
                  </span>
                </v-tooltip>
                <span v-else>
                  <p class="ma-0" v-for="item in props.item.listaCorretor">
                    {{
                      buscarEmail(item.idCorretor, listaCorretorResponsavel) 
                    }}
                  </p>
                </span>
              </td>
              <td class="themeGrey--text">
                {{
                  buscarTitulo(props.item.idInicioVigencia, listaIniciaVigencia)
                }}
              </td>
              <td class="themeGrey--text">
                <v-tooltip v-if=" props.item.listaRegiao != null && props.item.listaRegiao.length > 1" bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <span
                        v-for="(item, index) in props.item
                          .listaRegiao"
                      >
                      <span v-if="index == 0">
                          {{
                            buscarSigla(item.idRegiao, listaRegiao) +
                              "/"
                          }}
                        </span>
                        
                      <span
                        v-if="
                          props.item.listaRegiao.length > 1 &&
                            index == 1
                        "
                      >
                        {{
                          buscarSigla(item.idRegiao, listaRegiao) + "/ ..."
                        }}
                      </span>
                    </span>
                  </span>
                  </template>
                  <span >
                    <span class="ma-0" v-for="item in props.item.listaRegiao">
                      {{
                        buscarSigla(item.idRegiao, listaRegiao) +"/ "
                      }}
                    </span>
                  </span>
                </v-tooltip>
                <span v-else>
                  <span >
                    <p class="ma-0" v-for="item in props.item.listaRegiao">
                      {{
                        buscarSigla(item.idRegiao, listaRegiao) 
                      }}
                    </p>
                  </span>
                </span>
              </td>
              
              <td class="themeGrey--text">
                {{ formatMoney(props.item.valorFaixaPremioDe) }} -
                {{ formatMoney(props.item.valorFaixaPremioAte) }}
              </td>
              <td class="themeGrey--text">
                {{ props.item.ativo ? "Ativo" : "Inativo" }}
              </td>
              <td class="themeGrey--text text-xs-center">
                <v-btn
                  flat
                  color="secondary"
                  @click="buscarDadosClassificacao(props.item.id)"
                  >Editar</v-btn
                >
              </td>

            </template>
          </v-data-table>
          <div class="text-xs-center mb-4 pt-2">
            <v-pagination
              v-model="paginacao.page"
              :length="paginacao.totalPages"
              circle
            ></v-pagination>
          </div>
        </div>
      </template>
    </div>

    <v-snackbar
      :timeout="3000"
      :color="snackbar.sucesso ? 'success' : 'error'"
      multi-line
      v-model="snackbar.visivel"
    >
      {{ snackbar.mensagem }}
      <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
    </v-snackbar>

    <template>
      <v-dialog persistent width="900" v-model="dialogClassificacaoCotacao">
        <ModalClassificacaoCotacao
          :listaCoberturas="listaCoberturas"
          :listaCategorias="listaCategorias"
          :listaCargas="listaCargas"
          :listaIniciaVigencia="listaIniciaVigencia"
          :classificacaoRetornada="classificacaoRetornada"
          :listaRegiao="listaRegiao"
          :listaCorretorResponsavel="listaCorretorResponsavel"
          @fecharModal="dialogClassificacaoCotacao = false"
          @comecarLoading="loaderPagina = true"
          @fecharLoading="loaderPagina = false"
          @erroSalvarClassificacao="tratamentoErroClassificacao"
          @classificacaoSalva="tratamentoClassificacaoSalvar"
        ></ModalClassificacaoCotacao>
      </v-dialog>
    </template>
    <template>
      <v-dialog
        persistent
        v-model="loaderPagina"
        width="auto"
        content-class="elevation-0"
      >
        <v-card class="loader-overlay">
          <v-progress-circular
            indeterminate
            color="primary"
            :size="93"
            :width="5"
          ></v-progress-circular>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>
<script>
import ModalClassificacaoCotacao from "./ModalClassificacaoCotacao";
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import StarRating from "vue-star-rating";

export default {
  name: "GridClassificacaoCotacoes",
  components: {
    ModalClassificacaoCotacao,
    StarRating
  },
  data() {
    return {
      listaIniciaVigencia: [],
      listaCoberturas: [],
      listaCargas: [],
      listaCategorias: [],
      listaRegiao: [],
      listaCorretorResponsavel: [],
      classificacaoRetornada: null,

      dialogClassificacaoCotacao: false,
      loaderPagina: false,
      paginacao: {
        page: parseInt(sessionStorage.getItem("pageSolicitacaoCotacao")),
        size: 10,
        totalPages: 0
      },
      listaClassificacao: [],
      headerGridClassificacao: [
        { text: "Nome", value: "nome", sortable: false },
        { text: "Classificação", value: "classificacao", sortable: false },
        { text: "Categoria Tarifária", value: "catTarifaria", sortable: false },
        { text: "Tipo Cobertura", value: "tipoCobertura", sortable: false },
        {
          text: "Tipo de Carga Transportada",
          value: "tipoCargaTransportada",
          sortable: false
        },
        {
          text: "Corretor Parceiro",
          value: "corretorParceiro",
          width: "50px",
          sortable: false
        },
        { text: "Início Vigência", value: "inicioVigencia", sortable: false },
        { text: "Região", value: "regiao", sortable: false },
        {
          text: "Faixa de Prêmio",
          value: "valorFaixaPremioDe",
          sortable: false
        },
        { text: "Status", value: "ativo", sortable: false },
        {
          text: "Ação",
          value: "acao",
          align: "center",
          sortable: false
        }
      ],
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        }
      },
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ""
      }
    };
  },
  mounted() {
    if (sessionStorage.getItem("pageSolicitacaoCotacao") == null) {
      this.paginacao.page = 1;
    }
    this.buscarClassificacoes();
    this.buscaListaCoberturas();
    this.buscaListaCategorias();
    this.buscaListaCargas();
    this.buscarInicioVigencia();
    this.carregaEstados();
    this.buscarCorretorResponsavel();
  },
  watch: {
    "paginacao.page"(val) {     
      this.buscarClassificacoes();
      sessionStorage.setItem("pageSolicitacaoCotacao", val);
    },
  },
  methods: {
    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },
    buscarCorretorResponsavel() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarUsuariosApolice`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          return response.data;
        })
        .then(data => {
          this.listaCorretorResponsavel = data;
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },
    buscarDadosClassificacao(id) {
      this.loaderPagina = true;
      axios
        .get(`${process.env.URL_COTACAOMS}/v1/buscarDadosClassificacao/${id}`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(res => {
          return res.data;
        })
        .then(data => {
          this.classificacaoRetornada = data;
          this.classificacaoRetornada.listaRegiao =
            data.listaRegiao == null ? [] : data.listaRegiao;
          this.classificacaoRetornada.listaCorretorResponsavel =
            data.listaCorretorResponsavel == null
              ? []
              : data.listaCorretorResponsavel;
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Erro ao buscar classificações";
          this.loaderPagina = false;
        })
        .finally(() => {
          this.loaderPagina = false;
          this.dialogClassificacaoCotacao = true;
        });
    },
    tratamentoErroClassificacao() {
      this.snackbar.visivel = true;
      this.snackbar.sucesso = false;
      this.snackbar.mensagem = "Erro ao salvar classificação.";
    },
    tratamentoClassificacaoSalvar() {
      this.buscarClassificacoes();
      this.snackbar.visivel = true;
      this.snackbar.sucesso = true;
      this.snackbar.mensagem = "Classificação salva com sucesso.";
    },
    filtroFunctions() {
      const self = this;
      return {
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        }
      };
    },
    buscarClassificacoes() {
      this.loaderPagina = true;
      axios
        .get(
          `${
            process.env.URL_COTACAOMS
          }/v1/retornarListagemClassificacao?page=${this.paginacao.page -
            1}&size=${this.paginacao.size}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(res => {
          return res.data;
        })
        .then(data => {
          this.listaClassificacao = data.content;
          this.paginacao.totalPages = data.totalPages;
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Erro ao busca classificação";
          this.loaderPagina = false;
        })
        .finally(() => {
          this.loaderPagina = false;
        });
    },
    buscarInicioVigencia() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/retornaListaFiltroVigencia`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.listaIniciaVigencia =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Erro ao buscar de vigencia";
        });
    },
    buscaListaCoberturas() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/retornaListaFiltroCobertura`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.listaCoberturas =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Erro ao buscar listagem de coberturas";
        });
    },
    buscaListaCategorias() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/retornaListaCategoriaVeiculo`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.listaCategorias =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Erro ao buscar listagem de veiculos";
        });
    },
    buscaListaCargas() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/riscoCargasEventuais`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.listaCargas =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Erro ao buscar listagem de cargas";
        });
    },
    buscarTitulo(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          item => item.id === entity || item.id === entity
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },
    buscarEmail(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          item => item.id === entity || item.id === entity
        );
        if (campo) {
          return campo.email;
        }
      }
      return "-";
    },
    buscarSigla(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          item => item.id === entity || item.id === entity
        );
        if (campo) {
          return campo.sigla;
        }
      }
      return "-";
    },
    carregaEstados() {
      axios
        .get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstadosSemDiversos`)
        .then(response => {
          this.listaRegiao = response.data;
        });
    }
  }
};
</script>
<style>
.flex-custom-classificacao {
  display: flex !important;
  align-items: center !important;
}
.bloco-btn-segundo {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  margin-bottom: 20px !important;
}
.no-data-apolice {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  text-align: center;
}
.table-grid thead {
  background-color: #00456e;
}
.table-grid .column {
  color: #fff !important;
}
.table-grid th i {
  color: #fff !important;
}
.headline {
  color: #fff;
  font-size: 14px !important;
}
.loader-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent !important;
  height: 100%;
  overflow: hidden !important;
  box-shadow: none !important;
}
.linha-grid:hover {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/classificacao-cotacoes/GridClassificacaoCotacoes.vue